import { render, staticRenderFns } from "./CollateHalfContent.vue?vue&type=template&id=4b5075a4&"
import script from "./CollateHalfContent.vue?vue&type=script&lang=js&"
export * from "./CollateHalfContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports